"use client";

import { useEffect, useState, useTransition } from "react";
import { useRouter } from "next/navigation";
import { Search, X } from "lucide-react";

// Zoekveld dat tijdens het typen zoekt.
//
// Met een korte pauze ertussen: elke aanslag doorsturen zou voor "Lady Green"
// tien zoekopdrachten op de database afvuren terwijl alleen de laatste telt.
const PAUZE_MS = 300;

export function Zoekveld({
  begin,
  pad = "/zoeken",
  plaatshouder = "Machine, rijder of merk",
}: {
  begin: string;
  /** Pagina waar de zoekterm heen gaat; de favorietenpagina zoekt op zichzelf. */
  pad?: string;
  plaatshouder?: string;
}) {
  const [term, setTerm] = useState(begin);
  const [bezig, start] = useTransition();
  const router = useRouter();

  useEffect(() => {
    if (term === begin) return;

    const timer = setTimeout(() => {
      start(() => {
        router.replace(term.trim() ? `${pad}?q=${encodeURIComponent(term.trim())}` : pad, {
          scroll: false,
        });
      });
    }, PAUZE_MS);

    return () => clearTimeout(timer);
  }, [term, begin, pad, router]);

  return (
    <div className="px-4">
      <div className="flex items-center gap-2 rounded-xl border border-border bg-card px-3">
        <Search className="size-4 shrink-0 text-primary" aria-hidden />
        <input
          type="search"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder={plaatshouder}
          aria-label="Zoek een team"
          autoComplete="off"
          className="min-w-0 flex-1 bg-transparent py-3 text-white outline-none placeholder:text-muted-foreground"
        />
        {term && (
          <button
            type="button"
            onClick={() => setTerm("")}
            aria-label="Zoekopdracht wissen"
            className="shrink-0 rounded-full p-1 text-muted-foreground transition-colors hover:text-white"
          >
            <X className="size-4" aria-hidden />
          </button>
        )}
      </div>
      <p className="mt-1.5 h-4 text-xs text-muted-foreground" aria-live="polite">
        {bezig ? "Zoeken…" : ""}
      </p>
    </div>
  );
}
